import { STATES } from '../../lib/format'

// Плашка состояния размещения: цвет задаёт CSS по классу состояния
// (см. `.pill.<state>` в App.css), подпись — человеческая, из STATES.
export function StatusPill({ state }: { state: string }) {
  return <span className={`pill ${state}`}>{STATES[state] || state}</span>
}
